// DemoDataSection — Stage 10 Settings controls.
// 1. "Clear demo data" — resets the store to its empty/default state.
// 2. "Show Load Demo option" toggle — shows/hides the TopBar nav link.

import { useStore } from '../../store/selectors';
import { useAlert } from '@ascend/alert';

export function DemoDataSection() {
  const showLoadDemo = useStore((s) => s.settings.showLoadDemo);
  const setDefaults = useStore((s) => s.setDefaults);
  const clearDemoData = useStore((s) => s.clearDemoData);
  const valuationsCount = useStore((s) => Object.keys(s.valuations).length);
  const { confirm, alert } = useAlert();

  const handleClear = async () => {
    const ok = await confirm({
      title: 'Clear all data?',
      message:
        'This removes every entity, cap table, and valuation, returning the app to its empty starting state. Settings (theme, role, etc.) are preserved. This cannot be undone.',
      confirmLabel: 'Clear data',
      danger: true,
      type: 'warning',
    });
    if (!ok) return;
    clearDemoData();
    await alert({
      title: 'Data cleared',
      message: 'All entities, cap tables, and valuations have been removed.',
      type: 'success',
    });
  };

  return (
    <div className="settings-section">
      <h3>Demo Data</h3>
      <div className="form-group">
        <label htmlFor="show-load-demo" className="row-2">
          <input
            id="show-load-demo"
            type="checkbox"
            checked={showLoadDemo}
            onChange={(e) => setDefaults({ showLoadDemo: e.target.checked })}
          />
          Show &ldquo;Load Demo&rdquo; link in the top bar
        </label>
        <p className="field-detail mt-1">
          When enabled, a &ldquo;Load Demo&rdquo; button appears next to the brand
          area in the top bar. Disable to reduce UI clutter after onboarding.
        </p>
      </div>

      <div className="form-group">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleClear}
          disabled={valuationsCount === 0}
        >
          Clear demo data
        </button>
        <p className="field-detail mt-1">
          Removes all entities, cap tables, valuations, alerts, sign-offs, and
          audit events. {valuationsCount === 0 ? 'No data to clear.' : `${valuationsCount} valuation(s) present.`}
        </p>
      </div>
    </div>
  );
}
